<template>
  <b-modal v-model="modalVisible" centered hide-footer title="歷史紀錄">
    <template #default>
      <div class="history-list">
        <ul>
          <li v-for="(item) in logs" :key="item.serial">
            <p>
              {{ dateFormat(item.create_at) }} - {{ item.statusDesc }} <br/>
              {{ item.contentDesc }}
            </p>
          </li>
        </ul>
      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import moment from 'moment';
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegHistoryModal',
  data() {
    return {
      logs: [],
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    kid: {
      type: String,
      required: true,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.refresh();
      }
    },
  },
  mounted() {
  },
  methods: {
    dateFormat(timestamp) {
      return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },
    async refresh() {
      try {
        this.logs.splice(0);
        await this.handleAsyncTask(async () => {
          const logs = await this.$store.dispatch('api/getKegHistoryPromise', {kid: this.kid});
          for (const l of logs) {
            this.logs.push(l);
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.history-list {
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
